import { Fragment, useMemo } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { useNavigate } from 'react-router-dom';
import { useEventCallback } from '@mui/material';
import { NewAmountCrubs } from 'front-office/constants/amount-crubs';
import FormAmount, { AmountForm } from 'front-office/components/amount/form';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { toast } from 'react-toastify';
import { transformerDatasetAmount } from 'front-office/utils/transformer-dataset-amount';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { useUserProfile } from 'shell/hooks/use-user-profile';

const NewAmount = (): React.ReactElement => {
  const navigate = useNavigate();

  const { userProfile } = useUserProfile();

  const insertData = useHttpClient(
    `${__CERTIFICATION_API_URL__}/certificazione/importo-pagamento`,
    { options: { method: 'POST' } }
  );

  const onSubmit = useEventCallback((values?: AmountForm) => {
    const data = transformerDatasetAmount(values || {});

    (insertData({ data }) as ResponsePromise<void>).then(() => {
      toast.success('Operazione eseguita con successo');

      navigate('/sportello/ricerca-importo');
    });
  });

  const onCancel = useEventCallback(() => {
    navigate('/sportello/ricerca-importo');
  });

  const initialValues: AmountForm | null = useMemo(() => {
    if (userProfile.isLoading) {
      return null;
    }

    const servizio = userProfile.datiLogin?.key?.codiceEnte || '';

    return {
      code: undefined,
      description: undefined,
      amount: undefined,
      dateFrom: null,
      dateTo: null,
      codeAgency: servizio,
    } as AmountForm;
  }, [userProfile.datiLogin]);

  return (
    <Fragment>
      <Breadcrumbs items={NewAmountCrubs} />
      {initialValues ? (
        <FormAmount
          title="Nuovo Importo Pagamento"
          onSubmit={onSubmit}
          onCancel={onCancel}
          initialValues={initialValues}
        />
      ) : undefined}
    </Fragment>
  );
};

NewAmount.displayName = 'New Amount component';

export default NewAmount;
